import { Lov } from '@/models/apis/master/masterResponse';

export const EXTERNAL_REPORT_ABILITY_DRIVER = 'ドライバー';
export const EXTERNAL_REPORTS = 'external_reports';

export const COMPANY_KIND_HONSHA = 'honsha';
export const COMPANY_KIND_KYOKU = 'kyoku';
export const COMPANY_KIND_PARTNER = 'partner';

// 初期値を保証するための定数。
// 設定JSONに該当設定が存在する場合は、keyとnameをその値で上書きする。
export const EXTERNAL_REPORT_DEFAULT_PAGE: Lov = {
  id: 0,
  list_type: 'default_page',
  key: 'external_reports',
  val: '業務報告書',
  disp_order: 999,
};
